/*  src/pages/Signup.jsx  */
import React, { useState, useContext } from 'react';
import { Link, useNavigate }           from 'react-router-dom';
import API                             from '../services/api';
import { AuthContext }                 from '../context/AuthContext';
import '../styles/Auth.css';

export default function Signup() {
  const [step,   setStep]   = useState('form');      // 'form' | 'otp'
  const [form,   setForm]   = useState({
    name:'', studentId:'', email:'', password:'', role:'student', hostelType:'hostler', hostel:''
  });
  const [otp,    setOtp]    = useState('');
  const [hostels, setHostels] = useState([]);
  const [loading,setLoading]= useState(false);
  const { login }           = useContext(AuthContext);
  const navigate            = useNavigate();

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  React.useEffect(() => {
    API.get('/hostels?isActive=true')
      .then(res => setHostels(res.data || []))
      .catch(err => console.error('Failed to load hostels:', err));
  }, []);

  const submitSignup = async e => {
    e.preventDefault();


    if (!form.email.toLowerCase().endsWith('@bnbwu.edu.pk'))
      return alert('Use your BNBW University e-mail (…@bnbwu.edu.pk).');
    if (!form.studentId.trim())
      return alert('Student ID required.');
    if (!['hostler','non-hostler'].includes(form.hostelType))
      return alert('Please select Hostler or Non-Hostler.');

    try {
      setLoading(true);
      await API.post('/auth/register', form);        // backend sends OTP
      setStep('otp');
    } catch(err){
      alert(err.response?.data?.msg || err.message);
    } finally { setLoading(false); }
  };

  const submitOtp = async e => {
    e.preventDefault();
    if (otp.length !== 6) return alert('Enter the 6-digit code');

    try {
      setLoading(true);
      const { data } = await API.post('/auth/verify-otp', {
        email: form.email, otp
      });
      login(data);                                   // same shape as /login response
      navigate(`/${data.user.role}`);
    } catch(err){
      alert(err.response?.data?.msg || err.message);
    } finally { setLoading(false); }
  };

  /* ---------- UI ---------- */
  return (
    <div className="auth-container">
      {step === 'form' && (
        <>
          <h2>📝 Student Sign-Up</h2>
          <form onSubmit={submitSignup}>
            {/*   Name   */}
            <div className="form-group">
              <label>Name</label>
              <input name="name" value={form.name} onChange={handleChange} required/>
            </div>
            {/*   Student ID   */}
            <div className="form-group">
              <label>Student ID</label>
              <input name="studentId" value={form.studentId}
                     onChange={handleChange} placeholder="e.g. S22CIV123" required/>
            </div>
            {/*   Hostel Type   */}
            <div className="form-group">
              <label>Hostel Type</label>
              <select name="hostelType" value={form.hostelType} onChange={handleChange} required>
                <option value="hostler">Hostler</option>
                <option value="non-hostler">Non-Hostler</option>
              </select>
            </div>
            {/*   Hostel   */}
            <div className="form-group">
              <label>Hostel (Optional)</label>
              <select name="hostel" value={form.hostel} onChange={handleChange}>
                <option value="">-- Select Your Hostel --</option>
                {hostels
                  .filter(h => h.hostelType === form.hostelType)
                  .map(h => <option key={h._id} value={h._id}>{h.name}</option>)}
              </select>
            </div>
            {/*   Email   */}
            <div className="form-group">
              <label>BNBW University Email</label>
              <input type="email" name="email" value={form.email}
                     onChange={handleChange} placeholder="you@bnbwu.edu.pk" required/>
            </div>
            {/*   Password   */}
            <div className="form-group">
              <label>Password</label>
              <input type="password" name="password" value={form.password}
                     onChange={handleChange} required/>
            </div>

            <button type="submit" disabled={loading}>
              {loading ? 'Sending code…' : 'Sign Up'}
            </button>
          </form>

          <div className="footer-text">
            Already registered? <Link to="/login">Log In</Link>
          </div>
        </>
      )}

      {step === 'otp' && (
        <>
          <h2>📧 Verify your e-mail</h2>
          <p>
            We’ve sent a 6-digit code to <strong>{form.email}</strong>.<br/>
            Enter it below to activate your account.
          </p>
          <form onSubmit={submitOtp}>
            <div className="form-group">
              <input
                style={{letterSpacing:'0.3em',textAlign:'center'}}
                value={otp} onChange={e=>setOtp(e.target.value.replace(/\D/g,''))}
                placeholder="- - - - - -" maxLength={6} required
              />
            </div>
            <button type="submit" disabled={loading}>
              {loading ? 'Verifying…' : 'Verify & Continue'}
            </button>
          </form>

          <button className="link-btn" disabled={loading}
                  onClick={()=>API.post('/auth/send-otp',{email:form.email})}>
            Didn’t get a code? Resend
          </button>
        </>
      )}
    </div>
  );
}
